/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/components/ContextMenu/AbonelikContextMenu.js
import { Box, Text, Flex } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function AbonelikContextMenu({
  position,
  data,
  onClose,
  onYenile,
  onOpenGecmis,
  onOpenDetay,
  onOpenHatirlatma,
  onOpenTopluYenile,
  onOpenSonlandir,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 240, menuHeight: 300 });

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="140px"
      fontSize="11px"
      py={1}
    >
      <MenuItem
        label="Abonelik Yenile"
        onClick={() => {
          onYenile?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Hatırlatma Gönder"
        onClick={() => {
          onOpenHatirlatma?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Toplu Abonelik Yenile"
        onClick={() => {
          onOpenTopluYenile?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Abonelik Geçmişi"
        onClick={() => {
          onOpenGecmis?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Aboneliği Görüntüle"
        onClick={() => {
          onOpenDetay?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label={
          data?.satis_turu_raw === "Kiralık" || data?.satis_turu === "Kiralık" || data?.satis_turu === "Kiralama"
            ? "Kiralama Sonlandır"
            : "Aboneliği Sonlandır"
        }
        isDestructive
        onClick={() => {
          onOpenSonlandir?.(data);
          onClose?.();
        }}
      />
    </Box>
  );
}

function MenuItem({ label, onClick, isDestructive = false }) {
  return (
    <Flex
      align="center"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: isDestructive ? "red.50" : "gray.50",
        color: isDestructive ? "red.600" : "gray.900",
        transform: "scale(1.02)"
      }}
      onClick={onClick}
    >
      <Text 
        fontWeight="500" 
        color={isDestructive ? "red.500" : "gray.600"}
        fontSize="11px"
      >
        {label}
      </Text>
    </Flex>
  );
}

export default AbonelikContextMenu;